// extracted by mini-css-extract-plugin
module.exports = {"stack":"xvFSg","event-card-container":"_254m9","slider":"_1S_6k","shake":"ZpG5z"};